import { useRef, useState } from "react";
import { ReactComponent as PlusIcon } from "components/icons/plusIcon.svg";
import { clsx } from "clsx";
import { IFileData } from "./VerifyStep";
import "./styles/UploadAvatar.scss";

interface IUploadAvatarProps {
  onChange: (arg: IFileData | null) => void;
}

export const UploadAvatar = ({ onChange }: IUploadAvatarProps) => {
  let fieldRef = useRef(null);

  const [fileState, setFileState] = useState({
    isLoading: false,
    fileName: "",
    value: "",
    typesError: ""
  });

  const onSetRef = (elem: any) => {
    if (elem && fieldRef !== elem) {
      fieldRef = elem;
    }
  };

  const onHandleChange = () => {
    if (!fieldRef) {
      return null;
    }

    // @ts-ignore
    const { files } = fieldRef;

    setFileState({ ...fileState, isLoading: true });

    const { name } = files[0] || {};

    if (!name) {
      setFileState({
        ...fileState,
        fileName: "",
        typesError: "",
        isLoading: false
      });

      return;
    }

    // eslint-disable-next-line no-useless-escape
    const type = name.match(/\.([^\.]+)$/)[1].toLowerCase();
    const allowedTypes = ["jpg", "png", "jpeg"];

    if (!allowedTypes.includes(type)) {
      // @ts-ignore
      fieldRef.fileData = null;

      setFileState({
        fileName: "",
        typesError: "File types supported: JPG, PNG.",
        isLoading: false,
        value: ""
      });

      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      setFileState({
        fileName: name,
        isLoading: false,
        typesError: "",
        // @ts-ignore
        value: reader.result
      });

      // @ts-ignore
      fieldRef.fileData = files[0];

      if (typeof onChange === "function") {
        onChange({
          file_data: files[0],
          file_name: name
        });
      }
    };

    reader.onerror = () => {
      setFileState({ ...fileState, fileName: "", isLoading: false });

      if (typeof onChange === "function") {
        onChange(null);
      }
    };
    reader.readAsDataURL(files[0]);
  };

  const onClearFile = () => {
    if (onChange) {
      onChange(null);
    }

    setFileState({
      isLoading: false,
      typesError: "",
      fileName: "",
      value: ""
    });

    // @ts-ignore
    fieldRef.value = "";
  };

  const renderPreview = () => {
    if (!fileState.value) {
      return null;
    }

    return (
      <div className="UploadAvatar-Preview" onClick={onClearFile}>
        <img src={fileState.value} alt="avatar"/>
        <div className="UploadAvatar-PreviewRemove"></div>
      </div>
    );
  };

  const renderLabel = () => {
    const title = fileState.value ? "Upload Another" : "Add photo";
    const labelClsx = clsx(["UploadAvatar-Label", { "UploadAvatar-Label_isUploaded": !!fileState.value }]);

    return (
      <label className={labelClsx} htmlFor="file-upload">
        <input
          ref={ (elem) => onSetRef(elem) }
          id="file-upload"
          type="file"
          onChange={onHandleChange}
          accept="image/png, image/jpeg"
          className="UploadAvatar-Input"
        />
        <div className="UploadAvatar-Title">
          <span>{title}</span>
          <div>
            <PlusIcon />
          </div>
        </div>
      </label>
    );
  };

  const renderError = () => {
    if (!fileState.typesError) {
      return null;
    }

    return (
      <p className="UploadAvatar-Error">{fileState.typesError}</p>
    );
  };

  return (
    <div className="UploadAvatar">
      {renderPreview()}
      {renderLabel()}
      {renderError()}
    </div>
  );
};
